// The second phase of a Tenis10 competition (RELEASE-TENIS10 § 11 P51 (4), P54): the first N children of every group go through — no
// inter-group ranking — into a knockout drawn from tenis10.ro's fixed brackets where one fits, else by the Sportya draw (a group's
// children kept apart, the BYEs to the group winners), and the two semifinal losers play the small final.
// MIRROR: api Accounts `features/matches/helpers/tenis10Knockout.js` (TENIS10_FIXED_BRACKETS) and Events
// `features/phaseManagement/tenis10.js` (TENIS10_QUALIFIERS_PER_GROUP, TENIS10_ONE_GROUP_QUALIFIERS, TENIS10_RANKING_FIXED).

// The qualifiers / groups combinations tenis10.ro had a fixed bracket for (and the one-group finals that follow its 4 from 1).
const FIXED_BRACKETS = ["2/1", "3/1", "4/1", "4/2", "6/2", "6/3", "8/2", "8/4", "12/3", "12/4", "16/4"]
// A single group sends at most four children on: tenis10.ro's brackets for one group are 2, 3 and 4, and no draw keeps one group's
// children apart (Tudor 2026-10-29, variant B; PROD, Cupa Tenis Life Berceni).
export const ONE_GROUP_MAX_QUALIFIERS = 4

export const isTenis10Context = context => Boolean(context?.tenis10)

/**
 * The children each group may send on: at least one (two from a single group, a knockout needs two), at most its share of the capacity
 * (four from a single group).
 */
export const qualifiersPerGroupRange = ({ numberOfGroups, capacity }) => {
  const share = Math.max(0, Math.floor(Number(capacity) / Number(numberOfGroups)))
  return numberOfGroups === 1 ? { min: 2, max: Math.min(share, ONE_GROUP_MAX_QUALIFIERS) } : { min: 1, max: share }
}

/** What a phase of `perGroup` children from every group draws: its qualifiers, places, BYEs, bracket and small final. */
export const tenis10PhaseShape = (perGroup, numberOfGroups) => {
  const quota = perGroup * numberOfGroups
  const drawSize = 2 ** Math.ceil(Math.log2(quota))
  return { quota, drawSize, byes: drawSize - quota, fixedBracket: FIXED_BRACKETS.includes(`${quota}/${numberOfGroups}`), smallFinal: drawSize >= 4 }
}

export const groupsText = count => `${count} group${count === 1 ? "" : "s"}`
export const qualifiersRule = perGroup => `first ${perGroup} of every group`
